<template>
    <el-table v-if="componentShow" ref="treetable" :data="formatData" :row-style="showRow" :cell-style="cellStyle2" v-bind="$attrs" :height="tableHeight" v-table-scroll-position="tableScrollPosition"
              highlight-current-row @current-change="handleCurrentChange" :stripe="stripe">
        <el-table-column type="index" width="52" label="序号" align="center">
        </el-table-column>
        <el-table-column v-if="columns.length===0" width="150" :show-overflow-tooltip="true">
            <template slot-scope="scope">
                <span v-for="space in scope.row._level" :key="space" class="ms-tree-space"/>
                <span v-if="iconShow(0,scope.row)" class="tree-ctrl" @click="toggleExpanded(scope.$index)">
          <i v-if="!scope.row._expanded" class="el-icon-arrow-right"/>
          <i v-else class="el-icon-arrow-down"/>
        </span>
                {{ scope.$index }}
            </template>
        </el-table-column>
        <el-table-column v-for="(column, index) in columns" v-else :key="column.value" :label="column.text"
                         :width="column.width" :show-overflow-tooltip="true" :align="column.align ? column.align : 'left'" header-align="left">
            <template slot-scope="scope"><span
                    v-for="space in scope.row._level" v-if="index === 0" :key="space" class="ms-tree-space"/><span
                    v-if="iconShow(index,scope.row)" class="tree-ctrl" @click="toggleExpanded(scope.$index)">
                  <i v-if="!scope.row._expanded" class="el-icon-arrow-right"/>
                  <i v-else class="el-icon-arrow-down"/></span><span v-if="column.ischeck && stripe"><el-checkbox
                    :true-label="1" :false-label="0" v-model="scope.row[column.value]" @change="checkRow(scope.row[column.value],scope.row,column.value)"
                    :disabled="checkdisabled"></el-checkbox></span><span v-else-if="column.ischeck && !stripe"><el-checkbox
                    :true-label="1" :false-label="0" v-model="scope.row[column.value]" @change="checkRow(scope.row[column.value],scope.row,column.value)"
                    :disabled="checkDisFun(scope.row)"></el-checkbox></span><span
                    v-else-if="column.filter">{{$options.filters[column.filter](scope.row[column.value])}}</span><span
                    v-else-if="column.i18n && scope.row[column.value]">{{ $t(column.i18n+'.'+scope.row[column.value]) }}</span><span
                    v-else-if="column.toButton"><a href="javaScript:void(0);" @click="column.toButton(scope.row[column.value],scope.row,column.value)"
            >{{ scope.row[column.value] }}</a></span><span
                    v-else>{{ scope.row[column.value] }}</span></template>
        </el-table-column>
        <slot/>
    </el-table>
</template>

<script>
    import treeToArray from "./eval";
    export default {
        name: "TreeTable",
        props: {
            /* eslint-disable */
            data: {
                type: [Array, Object],
                required: true
            },
            columns: {
                type: Array,
                default: () => []
            },
            evalFunc: Function,
            evalArgs: Array,
            expandAll: {
                type: Boolean,
                default: false
            },
            tableHeight:{
                type:String
            },
            clickRow: Function,
            linkage:{
                type:Boolean,
                default:false
            },
            checkFun: Function,
            checkdisabled:{
                type:Boolean,
                default:false
            },
            cellStyle: Function,
            cellStyle2:Function,
            stripe:{
                type:Boolean,
                default:true
            },
            checkDis: Function
        },
        data(){
            return {
                componentShow:true,
                tableScrollPosition:false
            }
        },
        activated(){
            this.tableScrollPosition = false;
            this.tableScrollPosition = true;
        },
        computed: {
            // 格式化数据源
            formatData: function() {
                let tmp;
                if (!Array.isArray(this.data)) {
                    tmp = [this.data];
                } else {
                    tmp = this.data;
                }
                const func = this.evalFunc || treeToArray;
                const args = this.evalArgs
                    ? Array.concat([tmp, this.expandAll], this.evalArgs)
                    : [tmp, this.expandAll];
                return func.apply(null, args);
            }
        },
        methods: {
            checkDisFun: function (row) {
                if(this.checkDis){
                    return this.checkDis(row);
                }else{
                    return false;
                }
            },
            showRow: function(row) {
                const show = row.row.parent
                    ? row.row.parent._expanded && row.row.parent._show
                    : true;
                row.row._show = show;

                let showStyle = show ? "animation:treeTableShow 1s;-webkit-animation:treeTableShow 1s;" : "display:none;"

                if (this.cellStyle) {
                    showStyle += this.cellStyle(row);
                }
                return showStyle;
            },
            // 切换下级是否展开
            toggleExpanded: function(trIndex) {
                const record = this.formatData[trIndex];
                record._expanded = !record._expanded;
            },
            // 图标显示
            iconShow(index, record) {
                return index === 0 && record.children && record.children.length > 0;
            },
            handleCurrentChange(row){
                if(this.clickRow){
                    this.clickRow(row);
                }
            },
            setCurrentRow(row){
                if(row){
                    this.$refs['treetable'].setCurrentRow(row);
                }
            },
            checkRow(value, row,clo){
                this.$emit('checkbox-change',{value:value,col:clo});
                if(this.linkage){
                    if(row.children && row.children.length > 0){
                        this.setChildValue(row,value,clo);
                    }
                    if(value == '1'){
                        if(row.parent){
                            this.setParentValue(row,value,clo);
                        }
                    }
                }
            },
            setChildValue(row,value,clo){
                for (var i = 0; i < row.children.length; i++){
                    row.children[i][clo] = value;
                    if(row.children[i].children && row.children[i].children.length > 0){
                        this.setChildValue(row.children[i],value,clo);
                    }
                }
            },
            setParentValue(row,value,clo){
                row.parent[clo] = value;
                if(row.parent.parent){
                    this.setParentValue(row.parent,value,clo);
                }
            }
        },
        beforeDestroy(){
            this.componentShow = false;
        }
    };
</script>
<style rel="stylesheet/css">
    @keyframes treeTableShow {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
    @-webkit-keyframes treeTableShow {
        from {
            opacity: 0;
        }
        to {
            opacity: 1;
        }
    }
</style>

<style scoped>
    .ms-tree-space {
        position: relative;
        top: 1px;
        display: inline-block;
        font-style: normal;
        font-weight: 400;
        line-height: 1;
        width: 18px;
        height: 14px;
    }
    .ms-tree-space::before {
        content: "";
    }
    .processContainer {
        width: 100%;
        height: 100%;
    }
    table td {
        line-height: 26px;
    }
    .tree-ctrl {
        position: relative;
        cursor: pointer;
        color: #2196f3;
        margin-left: -18px;
    }
</style>


// WEBPACK FOOTER //
// src/components/TreeTable/index.vue